
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Bharatbenzbusonrent() {



    const cardData =
    {
        keyword: 'Bharatbenz Bus On Rent in Pune  ',
        heading: 'Amruta Travels: Bharatbenz Bus On Rent in Pune  ',
        headingDescription: 'Amruta Travels offers BharatBenz Bus On Rent in Pune, providing a luxurious and comfortable transportation solution for all your travel needs. Whether you are planning a corporate event, family trip, wedding, or group tour, our well-maintained BharatBenz buses ensure a smooth and enjoyable journey. Choose from our range of buses, including 35-seater, 40-seater, and 45-seater options, to suit your group size. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your travel in and around Pune simple and stress-free. Book your BharatBenz bus with Amruta Travels and embark on a journey of comfort and luxury!',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Located approximately 66 km from Pune, these twin hill stations are nestled in the Sahyadri ranges. Known for their lush green valleys, waterfalls, and pleasant climate, they offer attractions like Bhushi Dam, Tiger's Leap, and Rajmachi Fort. Adventure enthusiasts can indulge in trekking, camping, and paragliding activities."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Situated about 120 km from Pune, Mahabaleshwar is renowned for its strawberry farms, scenic viewpoints like Arthur's Seat, and the serene Venna Lake. Nearby Panchgani, at a distance of 100 km, offers attractions like Table Land and Parsi Point. Both hill stations provide a refreshing escape from city life."
  },
  {
    "title": "Matheran",
    "description": "Approximately 120 km from Pune, Matheran is India's smallest hill station and is unique for being a vehicle-free zone. Perched at an elevation of 800 meters, it offers panoramic views, colonial architecture, and 38 designated viewpoints, including Panorama Point and Louisa Point."
  },
  {
    "title": "Alibaug",
    "description": "Located around 140 km from Pune, Alibaug is a coastal town known for its clean beaches like Alibaug Beach and Nagaon Beach, as well as historical sites like Kolaba Fort. It's a popular destination for beach lovers and those seeking a tranquil seaside retreat."
  },
  {
    "title": "Kolad",
    "description": "Approximately 110 km from Pune, Kolad is famed for white-water rafting on the Kundalika River. The town also offers opportunities for kayaking, zip-lining, and camping, making it a haven for adventure seekers."
  },
  {
    "title": "Igatpuri",
    "description": "Situated about 240 km from Pune, Igatpuri is a hill station in the Western Ghats known for its misty mountains, waterfalls, and the Vipassana International Academy. It's an ideal spot for meditation, trekking, and enjoying nature's tranquility."
  },
  {
    "title": "Bhandardara",
    "description": "Located roughly 170 km from Pune, Bhandardara is a serene village offering attractions like the Bhandardara Lake, Randha Falls, and the historic Ratangad Fort. It's a perfect destination for nature lovers and those seeking solitude."
  },
  {
    "title": "Lavasa",
    "description": "Approximately 60 km from Pune, Lavasa is a planned city inspired by the Italian town of Portofino. It offers picturesque landscapes, water sports, and a range of dining options, making it a popular spot for weekend retreats."
  },
  {
    "title": "Goa",
    "description": "Situated about 450 km from Pune, Goa is India's premier beach destination. Known for its vibrant nightlife, Portuguese heritage, and sandy beaches like Baga and Anjuna, it offers a mix of relaxation and entertainment."
  },
  {
    "title": "Kaas Plateau",
    "description": "Around 140 km from Pune, the Kaas Plateau, also known as the 'Valley of Flowers of Maharashtra,' is a UNESCO World Natural Heritage site. During the monsoon season, it blooms with a variety of endemic flowers, attracting nature enthusiasts and photographers."
  }
],


  "services": [
    {
      "name": "35 Seater BharatBenz Bus on Rent in Pune",
      "description": "Amruta Travels offers 35-seater BharatBenz buses for rent in Pune, ideal for mid-sized groups planning outstation trips, corporate outings, weddings, or school picnics. These buses are equipped with air-conditioning, pushback seats, and a comfortable ride for long distances."
    },
    {
      "name": "Bharat Benz Sleeper Bus on Rent",
      "description": "Travel overnight in luxury with our Bharat Benz sleeper bus rentals in Pune. Designed for long-distance and overnight trips, these sleeper buses offer spacious berths, AC, clean interiors, and are perfect for religious tours, family travel, and corporate getaways."
    },
    {
      "name": "Bus On Rent (BharatBenz Bus) in Pune",
      "description": "Book a BharatBenz bus in Pune with Amruta Travels for premium travel experiences. Our buses are available for various needs including weddings, office trips, outstation tours, and VIP transportation with professional drivers and top-notch amenities."
    },
    {
      "name": "45 Seater Bharat Benz on Rent",
      "description": "The 45-seater Bharat Benz buses available for rent in Pune are ideal for large group tours, corporate events, and long-distance travel. These buses feature air-conditioned comfort, pushback seating, and reliable performance for every journey."
    },
    {
      "name": "Bharat Benz Bus on Rent for Company",
      "description": "Amruta Travels provides Bharat Benz buses for corporate rentals in Pune. These are best suited for daily employee transport, team outings, seminars, or conferences. Ensure timely, professional, and comfortable transport for your staff with our monthly rental plans."
    },
    {
      "name": "Bharat Benz Bus on Rent for Wedding Function",
      "description": "Make your wedding travel seamless with Bharat Benz buses. With stylish interiors, spacious seating, and smooth rides, our buses are ideal for guest transportation to and from wedding venues in and around Pune."
    },
    {
      "name": "Bharat Benz Small Bus",
      "description": "Need a smaller Bharat Benz bus for a small group or short trip? Amruta Travels provides compact Bharat Benz options that offer the same comfort and reliability in a more compact form, perfect for local events, family trips, and office shuttle needs."
    },
    {
      "name": "Bharat Benz on Rent for Pune to Shirdi",
      "description": "Travel from Pune to Shirdi in comfort with our Bharat Benz bus rental services. Suitable for spiritual tours and group pilgrimages, these buses offer AC, reclining seats, and an experienced driver to ensure a safe and timely journey."
    },
    {
      "name": "Bharat Benz on Rent for Pune to Shirdi Contact Number",
      "description": "For booking Bharat Benz buses from Pune to Shirdi, contact Amruta Travels. We offer well-maintained vehicles and experienced drivers for a spiritual journey to Sai Baba Temple. Call us for booking and pricing details."
    },
    {
      "name": "Bharat Benz on Rent for School Picnic Pune",
      "description": "Ensure safety and comfort for students with Bharat Benz bus rentals for school picnics. Our buses are inspected, clean, and equipped with safety features, making them ideal for educational institutions organizing field trips or outings."
    },
    {
      "name": "Bharat Benz Hire on Rent in Pune",
      "description": "Hire Bharat Benz buses from Amruta Travels for local or long-distance travel. With flexible packages, comfortable interiors, and a reputation for reliability, these buses serve both casual and professional travel requirements in Pune."
    },
    {
      "name": "Bharat Benz on Rent for Event in Pune",
      "description": "Whether you're organizing a cultural, corporate, or private event, Bharat Benz buses from Amruta Travels offer a perfect blend of style and convenience. Our event rental options include flexible routes, AC interiors, and on-time service."
    },
    {
      "name": "Bharat Benz Hire for Corporate Events",
      "description": "Make your corporate event transportation seamless with Bharat Benz buses. Ideal for ferrying employees or guests to off-site locations or seminars, these buses offer an executive travel experience with a professional driver and clean, comfortable interiors."
    },
    {
      "name": "57 Seater AC Bharat Benz on Rent in Pune",
      "description": "Book our spacious 57-seater AC Bharat Benz buses for weddings, religious trips, large group tours, or corporate events in Pune. These buses feature plush seating, air conditioning, and a smooth ride for longer journeys."
    }
  ],
  "tableData": [
    ["35 Seater BharatBenz Bus on Rent in Pune", "Bharat Benz Sleeper Bus on Rent"],
    ["Bus On Rent (BharatBenz Bus) in Pune", "45 Seater Bharat Benz on Rent"],
    ["Bharat Benz Bus on Rent for Company", "Bharat Benz Bus on Rent for Wedding Function"],
    ["Bharat Benz Small Bus", "Bharat Benz on Rent for Pune to Shirdi"],
    ["Bharat Benz on Rent for Pune to Shirdi Contact Number", "Bharat Benz on Rent for School Picnic Pune"],
    ["Bharat Benz Hire on Rent in Pune", "Bharat Benz on Rent for Event in Pune"],
    ["Bharat Benz Hire for Corporate Events", "57 Seater AC Bharat Benz on Rent in Pune"]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Luxury and Comfort with Bharatbenz Bus Rentals in Pune",
    "WhyChoosedescription": "Amruta Travels offers the elite Bharatbenz buses for rent in Pune, providing a luxury travel experience that combines high performance, comfort, and reliability. Whether you're planning a corporate event, a wedding, or a long-distance trip, our Bharatbenz buses provide a premium experience with cutting-edge technology, smooth ride quality, and spacious interiors, making your journey truly comfortable."
  },
  {
    "WhyChooseheading": "Perfect for Corporate, Events, and Group Travel",
    "WhyChoosedescription": "Bharatbenz buses are perfect for corporate travel, weddings, large family trips, and group outings. With spacious seating and luxurious interiors, they cater to both short and long-distance travel needs. Whether you're transporting employees to a conference or guests to a wedding, these buses offer the best in terms of comfort, safety, and luxury."
  },
  {
    "WhyChooseheading": "State-of-the-Art Features for Maximum Comfort",
    "WhyChoosedescription": "Our Bharatbenz buses are equipped with modern features such as plush reclining seats, high-end air conditioning, entertainment systems, individual USB charging ports, and ample luggage space. The ergonomically designed seats and smooth suspension system ensure that every passenger experiences maximum comfort and a fatigue-free journey."
  },
  {
    "WhyChooseheading": "Powerful and Safe Travel with Bharatbenz",
    "WhyChoosedescription": "Bharatbenz buses are renowned for their powerful engines and exceptional driving performance. Designed to provide a smooth ride even on long-distance journeys, these buses are equipped with the latest safety features including ABS, airbags, and GPS tracking for added security. Our buses meet stringent safety standards, ensuring that your group travels securely to any destination."
  },
  {
    "WhyChooseheading": "Affordable Luxury with Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels offers competitive and transparent pricing for Bharatbenz bus rentals in Pune. While providing a premium experience, our rates remain affordable. We offer all-inclusive pricing that covers fuel, tolls, driver allowances, and taxes with no hidden fees, so you can plan your budget confidently and enjoy a luxurious trip without breaking the bank."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Smooth and Safe Travel",
    "WhyChoosedescription": "Our Bharatbenz buses are driven by highly trained, experienced, and professional drivers who prioritize safety, punctuality, and passenger comfort. They are well-versed in navigating both local routes and long-distance highways, ensuring a smooth and timely journey. Our drivers also maintain the highest standards of customer service, making your travel experience even more enjoyable."
  },
  {
    "WhyChooseheading": "Ideal for Long-Distance Tours and Outstation Trips",
    "WhyChoosedescription": "For long-distance tours, pilgrimages, and outstation trips, Bharatbenz buses provide unmatched comfort. Whether it’s a trip to Shirdi, Goa, Mahabaleshwar, or any other destination, the powerful engine and smooth ride of Bharatbenz ensure your group enjoys the journey as much as the destination. With spacious seating and modern amenities, your group can travel comfortably for hours."
  },
  {
    "WhyChooseheading": "24/7 Customer Support and Easy Booking",
    "WhyChoosedescription": "Renting a Bharatbenz bus is a seamless process with Amruta Travels. You can book online, via phone, or in person at our office. Our 24/7 customer support ensures that all your booking, itinerary, and route inquiries are handled promptly, and we are always available to make any last-minute changes if required."
  }
]

















    }

const faqData = [
  {
    question: 'Can I rent a Bharatbenz bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers Bharatbenz buses for rent in Pune. Known for their comfort, performance, and durability, Bharatbenz buses are ideal for both local and outstation trips.',
  },
  {
    question: 'What makes the Bharatbenz bus ideal for travel?',
    answer: 'Bharatbenz buses are equipped with modern amenities such as spacious seats, air conditioning, superior suspension, and large luggage compartments, making them perfect for long-distance travel and large groups.',
  },
  {
    question: 'Are Bharatbenz buses available for both local and outstation trips?',
    answer: 'Yes, our Bharatbenz buses are available for both local travel within Pune and outstation trips to popular destinations like Shirdi, Mahabaleshwar, Lonavala, Goa, and more.',
  },
  {
    question: 'How many passengers can a Bharatbenz bus accommodate?',
    answer: 'Our Bharatbenz buses come in various seating capacities, including 32, 35, 40, and 50 seats, ensuring comfort for both small and large groups.',
  },
  {
    question: 'Do you provide drivers with Bharatbenz bus rentals?',
    answer: 'Yes, all Bharatbenz bus rentals include an experienced and licensed driver who will ensure the safety and comfort of your group throughout the journey.',
  },
  {
    question: 'How much does it cost to rent a Bharatbenz bus in Pune?',
    answer: 'The rental cost depends on factors such as the bus type, trip duration, distance, and services provided. Please reach out to us with your travel details for a customized quote.',
  },
  {
    question: 'Can I book a Bharatbenz bus for corporate or private events?',
    answer: 'Definitely! Bharatbenz buses are often chosen for corporate events, family gatherings, weddings, and group tours due to their luxury and comfort.',
  },
  {
    question: 'Are the Bharatbenz buses well-maintained and sanitized?',
    answer: 'Yes, all our Bharatbenz buses are thoroughly maintained and sanitized before every trip to ensure the highest standards of safety, hygiene, and comfort.',
  },
  {
    question: 'Why should I choose Amruta Travels for renting a Bharatbenz bus?',
    answer: 'Amruta Travels is known for providing high-quality, professional service. Our Bharatbenz buses are top-of-the-line vehicles that ensure a smooth, comfortable, and hassle-free travel experience.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Anil Patil',
    role: 'Business Executive, Pune',
    text: 'We rented a Bharatbenz bus for a corporate retreat. The ride was smooth, the bus was clean, and the service was professional. I highly recommend Amruta Travels for such trips!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Aarti Deshmukh',
    role: 'Wedding Planner',
    text: 'The Bharatbenz bus we rented from Amruta Travels was perfect for transporting our wedding guests. Spacious, comfortable, and punctual – everything went smoothly. Thank you for a great service!',
    rating: 5,
  },
];









































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bharatbenz Bus on Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/bharatbenz-bus-on-rent-pune.jpg",
  "description": "Hire Bharat Benz buses in Pune for various occasions, including weddings, corporate events, picnics, and long-distance trips. Options include 35-seater, 45-seater, 57-seater AC Bharat Benz buses. Reliable, comfortable, and luxurious buses for your travel needs.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "13260"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7500",  // Adjust price based on service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bharatbenz-bus-on-rent-in-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Bharatbenz Bus on Rent in Pune | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent a Bharat Benz bus in Pune for weddings, corporate events, picnics, and more. Choose from 35, 45, and 57-seater buses for a luxurious and comfortable travel experience." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/66.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bharatbenzbusonrent;